import { render, staticRenderFns } from "./watchlistDetails.vue?vue&type=template&id=4464454c&scoped=true"
import script from "./watchlistDetails.vue?vue&type=script&lang=js"
export * from "./watchlistDetails.vue?vue&type=script&lang=js"
import style0 from "./watchlistDetails.vue?vue&type=style&index=0&id=4464454c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4464454c",
  null
  
)

export default component.exports